import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, MapPin } from 'lucide-react';
import { events } from '../data/events';

const fadeInUpOnView = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true }
};

const cardFadeOnView = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true }
};

export const Schedule = () => {
  return (
    <section id="schedule" className="py-24 bg-[#0A2240]" data-testid="schedule-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          {...fadeInUpOnView}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="text-xs md:text-sm font-bold uppercase tracking-[0.2em] text-[#C9A84C] mb-4">
            Upcoming Events
          </div>
          <h2
            className="text-3xl md:text-4xl lg:text-5xl font-extrabold uppercase tracking-tight text-white"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
            data-testid="schedule-title"
          >
            Schedule
          </h2>
        </motion.div>

        {events.length === 0 ? (
          <div className="bg-[#061324] border border-white/10 rounded-sm p-12 text-center">
            <p className="text-[#94A3B8]">No scheduled events at this time. Check back soon!</p>
          </div>
        ) : (
          <motion.div
            {...cardFadeOnView}
            transition={{ duration: 0.6 }}
            className="bg-[#061324] border border-white/10 rounded-sm overflow-hidden"
          >
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="border-b border-white/10 bg-[#0A2240]/50">
                    <th className="text-left px-6 py-4 text-xs font-bold uppercase tracking-wide text-[#C9A84C]">
                      Date
                    </th>
                    <th className="text-left px-6 py-4 text-xs font-bold uppercase tracking-wide text-[#C9A84C]">
                      Event
                    </th>
                    <th className="text-left px-6 py-4 text-xs font-bold uppercase tracking-wide text-[#C9A84C]">
                      Location
                    </th>
                    <th className="text-left px-6 py-4 text-xs font-bold uppercase tracking-wide text-[#C9A84C]">
                      Type
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {events.map((event) => (
                    <tr
                      key={event.id}
                      className="border-b border-white/5 hover:bg-[#0A2240]/30 transition-colors"
                      data-testid={`schedule-row-${event.id}`}
                    >
                      <td className="px-6 py-4">
                        <div className="flex items-center gap-2 text-white">
                          <Calendar size={16} className="text-[#C9A84C]" />
                          <span className="font-semibold">{event.date}</span>
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <div className="text-white font-bold" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                          {event.title}
                        </div>
                        {event.description && (
                          <div className="text-sm text-[#94A3B8] mt-1">{event.description}</div>
                        )}
                      </td>
                      <td className="px-6 py-4">
                        <div className="flex items-center gap-2 text-[#94A3B8]">
                          <MapPin size={16} />
                          <span>{event.location}</span>
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <span className="inline-block px-3 py-1 bg-[#C9A84C]/10 border border-[#C9A84C]/30 text-[#C9A84C] text-xs font-bold uppercase tracking-wide rounded-sm">
                          {event.event_type}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </motion.div>
        )}
      </div>
    </section>
  );
};
